import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
export function Problems() {
  return <section aria-labelledby="problemas-title" className="w-full bg-ink-800" data-id="element-148" data-mp="1czwpwhwsciqm">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-20" data-id="element-149" data-mp="1cxtpr51x5986">
        <div className="mx-auto max-w-3xl text-center" data-id="element-150" data-mp="1hxy6mw6qo5yx">
          <SectionLabel data-id="element-151" data-mp="kb932hwe1lay">La realidad del fútbol juvenil argentino</SectionLabel>
          <h2 id="problemas-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-152" data-mp="k94p174rz5wy">
            ¿Sos padre de un chico que juega al fútbol? Estos problemas te van a resultar familiares.
          </h2>
        </div>
        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-153" data-mp="z1gbe4solnxx">
          {problems.map(problem => <li key={problem} className="flex items-start gap-4 rounded-xl border border-ink-border bg-ink-card p-5 shadow-panel transition-colors duration-150 ease-out hover:border-red-500/40" data-id="element-154" data-mp="1khkcpqigijw">
              <span aria-hidden="true" className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-500/15 text-red-400" data-id="element-155" data-mp="18fl30zui5ce">
                <XIcon className="h-4 w-4" strokeWidth={3} data-id="element-156" data-mp="3no0a511xc502" />
              </span>
              <p className="text-[15px] leading-relaxed text-body" data-id="element-157" data-mp="3nlw7snjobe1w">{problem}</p>
            </li>)}
        </ul>
        <div className="mt-10 rounded-2xl border border-ink-border bg-ink-950 p-8 text-center shadow-panel" data-id="element-158" data-mp="3enbu60syzukj">
          <p className="font-display text-2xl font-bold leading-snug text-white md:text-3xl" data-id="element-159" data-mp="39nfs473u2d7m">
            ¿Hasta cuándo vas a tomar decisiones importantes sin la información correcta?
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-base text-subtle" data-id="element-160" data-mp="17x4ackw5oi9n">
            El sistema del fútbol juvenil argentino no te explica sus reglas.{' '}
            <span className="font-semibold text-brand-greenSoft" data-id="element-161" data-mp="12veyj31400ki">Este método sí.</span>
          </p>
        </div>
      </div>
    </section>;
}